var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowRight05 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  fillRule: "evenodd",
  d: "M.246 11.834 5.58 6.5.246 1.167 1 .413 7.088 6.5 1 12.588z",
  clipRule: "evenodd"
})));
export default SvgIconArrowRight05;